import React from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  List,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  EditButton,
  Filter,
  NumberInput,
  BooleanInput,
  DateField,
  CreateButton,
  ExportButton,
} from 'react-admin';
import Toolbar from '@material-ui/core/Toolbar';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';

import resourceLocales from './locales';
import resourceConfig from './config';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import docStatusSystem from '../docStatusSystem';
import DateInput from '../../../../components/DateInput';
import exporter from '../../../../utils/exporter';
import inventoryP from '../inventoryP';
import inventoryImport from '../inventoryImport';
import directionType from '../directionType';
import docStatus from '../docStatus';
import docLinkType from '../docLinkType';
import errorModel from '../errorModel';
import SendButton from './SendButton';
import ExportDocButton from '../docH/ExportDocButton';
const ResourceIcon = BookmarkIcon;

const resourceToString = (x) => `#${x.id}`;

const listStyles = {};

const PButton = (props) => {
  return (
    <inventoryP.LinkToList
      label={`resources.${resourceConfig.name}.inventoryP`}
      filter={{
        overEntityIds: props.record.id,
      }}
    />
  );
};

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <inventoryImport.OpenButton />
    <CreateButton basePath={basePath} to={`${basePath}/create`} />
    <ExportDocButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'actionId'} />
    <TextInput source={'checkStatus'} />
    <TextField source={'creatorUsername'} />
    <directionType.Input source={'direction'} />
    <docStatus.Input source={'docStatus'} />
    <TextInput source={'docnum'} />
    <TextInput source={'documentId'} />
    <docLinkType.Input source={'documentLinkType'} />
    <NumberInput source={'documentLinkId'} />
    <docStatusSystem.Input source={'documentSystemStatus'} />
    <TextInput source={'guid'} />
    <DateInput
      source={'inventory_date'}
      label={`resources.${resourceConfig.name}.fields.inventory_date`}
    />
    <TextInput source={'numdoc'} />
    <TextInput source={'productGroup'} />
    <TextInput source={'receiverId'} />
    <TextInput source={'requestId'} />
    <BooleanInput source={'runningBefore'} />
    <TextInput source={'subjectId'} />
  </Filter>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    actions={<ResourceActions />}
    exporter={exporter}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />
      <directionType.Field source={'direction'} />
      <TextField source={'numdoc'} />
      <docStatusSystem.Field source={'documentSystemStatus'} />
      <DateField
        source={'inventory_date'}
        label={`resources.${resourceConfig.name}.fields.inventory_date`}
      />

      <SendButton />
      <errorModel.LinkToRelatedList type={'INVENTORY'} />
      <PButton />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.id}&quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source={'actionId'} />
      <TextInput source={'checkStatus'} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <TextInput source={'errors'} />
      <TextInput source={'guid'} />
      <DateInput
        source={'inventory_date'}
        label={`resources.${resourceConfig.name}.fields.inventory_date`}
      />
      <TextInput source={'ismpDocType'} />
      <TextInput source={'numdoc'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'productGroup'} />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <BooleanInput source={'runningBefore'} />
      <TextInput source={'subjectId'} />
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm redirect={false}>
      <TextField source={'id'} />
      <TextInput source={'actionId'} />
      <TextInput source={'checkStatus'} />
      <TextField source={'creatorUsername'} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      <docLinkType.Input source={'documentLinkType'} />
      <NumberInput source={'documentLinkId'} />
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <TextInput source={'errors'} />
      <TextInput source={'guid'} />
      <DateInput
        source={'inventory_date'}
        label={`resources.${resourceConfig.name}.fields.inventory_date`}
      />
      <TextInput source={'ismpDocType'} />
      <TextInput source={'numdoc'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'productGroup'} />
      <TextInput source={'receiverId'} />
      <TextInput source={'requestId'} />
      <BooleanInput source={'runningBefore'} />
      <TextInput source={'subjectId'} />
    </SimpleForm>
  </Edit>
);

const ResourceStringField = ({ record }) => <span>{resourceToString(record)}</span>;

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <ResourceStringField />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={resourceToString} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={resourceToString} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      inventory_date: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
    },
  },
};
